<template>
    <div class="answers-page" v-if="pageSetup != null">
        <div class="container">
            <div class="section-title-new">
                <h1>{{ pageSetup.quest_page_title }}</h1>
            </div>
            <div class="answer-items" id="accordion" aria-multiselectable="true">
                <div class="panel" v-for="(panel, index) in pageSetup.quest_list" :key="index">
                    <div class="panel-title" :style="'background-color:' + panel.bg_color">
                        <a :href="'#collapsePanelItem' + index" class="panel-link" data-parent="#accordion" data-toggle="collapse" :aria-expanded="[index === 0 ? true : false]">
                            <span>{{panel.category.name}}</span>
                            <div class="btn-press">
                                <svgIcon name="arrow-up" class="icon-arrow-up"/>
                            </div>
                        </a>
                    </div>
                    <div :id="'collapsePanelItem' + index" class="panel-collapse collapse" :class="{ 'in': index === 0 }">
                        <div class="items-list">
                            <div class="item" v-for="item in panel.quest_list">
                                <h4 v-html="item.quest"></h4>
                                <div class="desc"><p v-html="item.answer.desc"></p></div>
                                <div class="more-list" v-if="item.answer.list_init == 'true'" :class="'more-list-' + panel.category.key">
                                    <ul :class="'list-width-' + item.answer.list.length">
                                        <li v-for="list in item.answer.list">
                                            <h5 v-html="list.title"></h5>
                                            <p v-html="list.desc" v-if="list.desc != ''"></p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="more-desc" v-if="item.answer.list_init == 'true' && item.answer.list_desc != ''"><p v-html="item.answer.list_desc"></p></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue';
	import formPage from '@/components/forms/form-page.vue';	
    export default {
        name: 'answers--page',
        components: {
            formPage,
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            pageSetup: 'loadAnswersPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.answersPage != null) {
                next(vm => {
                    setTimeout(() => {
                        vm.$parent.$refs.topProgress.done();
                    }, 300);
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getAnswersPageData').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            setTimeout(() => {
                                vm.$parent.$refs.topProgress.done();
                            }, 300);
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'answers';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/answers/answers-page.scss';
    @import '@/styles/components/answers/answers-page-respond.scss';
    // @import '@/styles/respond/news/news-respond.scss';
</style>